import React, { useContext } from "react";
import { useHistory } from "react-router";
import { IMenuItemProps } from "../../@interfaces";
import MenuContext from "../../contexts/menu";
import { useTheme } from "styled-components";
import { MdKeyboardArrowRight } from "react-icons/md";
import Text from "../text";


const MenuItem: React.FC<IMenuItemProps> = ({ label, link, Icon, isActive, onClick }) => {
  const history = useHistory();
  const { toggleMenu, isOpen } = useContext(MenuContext);
  const theme = useTheme();


  function handleClick() {
    history.push(link);
    onClick?.();
  }

  return (
    <div className={`group transition-all flex p-2.5 hover:bg-gray-500 hover:text-gray-50 mb-[14px] cursor-pointer justify-between gap-[55px] lg:gap-[55px]  ${isActive && "bg-gray-700"}  rounded-[8px]`} onClick={handleClick} >
      <div className='flex items-center  gap-[14px]'>
        <Icon size={16} className={`transition-all  ${isActive ? "text-white" : "text-[#C3CAD9]"}`} />
        <Text className={`!transition-all !text-nowrap group-hover:!text-gray-50  !font-[Roboto] ${isActive ? "!text-white" : "!text-[#828895]"} !text-sm`}>{label}</Text>
      </div>
      <MdKeyboardArrowRight className={`${isActive ? "text-transparent" : "text-transparent"}`} />
    </div>
  )
}

export default MenuItem;